import React from "react";
import Toolbar from "../components/ToolBar";

const GitHubPage: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Release Management</h1>
        <p className="text-sm text-gray-500 mt-1">Plan and promote fix versions across environments</p>
      </div>
      <Toolbar />
    </div>
  );
};

export default GitHubPage;